import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from "@/page/Dashboard";
// import Chart from "@/page/SentChart";

import MailTemplateLayout from "@/page/template/mail/layout/MailTemplateLayout";
import MailTemplateLayoutUpdate from "@/page/template/mail/layout/MailTemplateLayoutUpdate";
import MailTemplateLayoutCreate from "@/page/template/mail/layout/MailTemplateLayoutCreate";
import EventTypeMng from "@/page/template/event/EventTypeMng";
import EventTypeDetail from "@/page/template/event/EventTypeDetail";
import SendLogs from "@/page/logs/SendLogs";

import i18n from '@/config/i18n'
import Login from "@/page/Login";
import ClientCodeMng from "@/page/code/ClientCodeMng";
import UserMng from "@/page/user/UserMng";
import constant from "@/config/const/const";
import SenderCodeMng from "@/page/code/SenderCodeMng";
// import MainPage from "@/page/MainPage";



// let trans = function(name) {
//     console.log(i18n.messages[i18n.locale][name])
//     console.log(i18n.locale)
//     return i18n.messages[i18n.locale][name]
// }


Vue.use(VueRouter)

const list = [
    {
        path: '/login',
        // name: trans('menu.dashboard'),
        name: 'Login',
        text: 'Login',
        hide: true,
        component: Login
    },
    {
        path: '/main',
        name: 'Main',
        text: 'Main',
        icon: 'icon-graph',
        // component: MainPage,
        component: Dashboard,     // dashboard 기능이 추가 될 경우 사용
        main: true, // role에 상관없이 접속가능한 default page , path 는 redirect path 와 동일해야 함 - 로그인시 권한이 아무것도 없을 경우 접속 가능한 page

    },
    {
        path: '#',
        name: 'Template Management',
        text: 'Template Management',
        icon: 'icon-price-tag3',
        defaultPath:'/template/management/events',
        role: constant.ROLES.TEMPLATE_MANAGEMENT,
        child: [
            {
                path: '/template/management/events',
                name: 'Event List',
                text: 'Event List',
                component: EventTypeMng,
                role:constant.ROLES.EVENT_LIST
            },
            {
                path: '/template/management/events/detail',
                name: 'eventDetails',
                text: 'Event Details',
                component: EventTypeDetail,
                hide:true,
                role: constant.ROLES.TEMPLATE_LIST
            },
        ],
    },
    {
        path: '#',
        name: 'Mail Layout Management',
        text: 'Mail Layout Management',
        icon: 'icon-mail5',
        defaultPath:'/mail/management/layout',
        role:constant.ROLES.MAIL_LAYOUT_MANAGEMENT,
        child: [
            {
                path: '/mail/management/layout',
                name: 'MailLayout',
                text: 'Mail Layout',
                component: MailTemplateLayout,
                role:constant.ROLES.MAIL_LAYOUT_LIST
            },
            {
                path: '/mail/management/layout/create',
                name: 'Create',
                text: 'Mail Layout Create',
                component: MailTemplateLayoutCreate,
                hide:true,
                role:constant.ROLES.MAIL_LAYOUT_SAVE,
            },
            {
                path: '/mail/management/layout/update',
                name: 'LayoutUpdate',
                text: 'Layout Update',
                component: MailTemplateLayoutUpdate,
                props: true,
                hide:true,
                role:constant.ROLES.MAIL_LAYOUT_SAVE
            },
        ],
    },
    {
        path: '/sendLog',
        // name: trans('menu.dashboard'),
        name: 'SendLog',
        text: 'Send Log',
        icon: 'icon-database4',
        component: SendLogs,
        role:constant.ROLES.SEND_LOG
    },
    {
        path: '#',
        name: 'Settings',
        text: 'Settings',
        icon: 'icon-gear',
        defaultPath:'/settings/code',
        role:constant.ROLES.SETTINGS,
        child: [
            {
                path: '/settings/clientCode',
                name: 'Client Code',
                text: 'Client Code',
                component: ClientCodeMng,
                role:constant.ROLES.SETTINGS_CODE
            },
            {
                path: '/settings/user',
                name: 'UserMng',
                text: 'User',
                component: UserMng,
                role:constant.ROLES.SETTINGS_USER
            },
            {
                path: '/settings/senderCode',
                name: 'Sender Code',
                text: 'Sender Code',
                component: SenderCodeMng,
                role:constant.ROLES.SETTINGS_CODE
            },
        ],
    },
    {
        path: '*',
        redirect: '/main',
        hide:true
    }
]
const routes = [];
list.forEach(function(item) {
    routes.push(item);
    if(item.child) routes.push(...item.child)
})

const router = new VueRouter({
    mode: 'history',
    routes,
    list
    // scrollBehavior: () => ({ y: 0 })
})
router.beforeResolve ((to, from, next)=> {
    if(to.path === 'login') {
        next()
    } else {
        let user = router.app.$store.getters[constant.GETTERS.GET_USER]
        if(!user) {
            router.app.$store.dispatch(constant.ACTIONS.INIT_USER,user)
            user = router.app.$store.getters[constant.GETTERS.GET_USER]
        }
        if(to.name === 'Main') next()
        let array = router.options.routes.filter(item=> item.name === to.name)
        if(array && array.length >0) {
            if(user) {
                if(user.data.usrRole.includes(array[0].role)) {
                    next()
                } else {
                    next('/')
                }
            } else {
                next()
            }
        }
    }
})
export default router
